import Vue from 'vue';

export default () => Vue.notify({
  group: 'foo',
  clean: true
});
